'use client';
import styled from 'styled-components';
import Tag from '@/ui/Tag';

export const ModalityTag = styled(Tag)`
  font-size: 12px;
  font-family: var(--font-family-mono);
  padding: 2px 5px;
  border-radius: 5px;
`;
